"use client";

import React, { useMemo } from "react";
import { useAppStore } from "@/store/useAppStore";
import { useAuth } from "@/hooks/useAuth";
import Link from "next/link";
import {
  authMobileNavigationList,
  notAuthMobileNavigationList,
} from "@/utils/mobileNavigation";

export const MobileNavigationList = () => {
  const { setIsMenuOpen } = useAppStore();
  const { user } = useAuth();

  const { activeTab, setActiveTab } = useAppStore();

  const mobileNavigationList = useMemo(
    () => (user ? authMobileNavigationList : notAuthMobileNavigationList),
    [user]
  );
  return (
    <div className="flex flex-col">
      {mobileNavigationList.map((tab) => (
        <Link
          key={tab.id}
          onClick={() => {
            setActiveTab(tab.id);
            setIsMenuOpen(false);
          }}
          href={`/${tab.href}`}
          className={`py-3 text-lg font-medium transition-colors border-b border-[#1C1C1E] ${
            activeTab === tab.id
              ? "text-white"
              : "text-[#808080] hover:text-white"
          }`}
        >
          {tab.label}
        </Link>
      ))}
    </div>
  );
};
